/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import {
    useEffect, useRef,
    useState,
} from 'react';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

export default function YotpoClickEvent(dispatch) {
    const clickableDivRef = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);
    if (typeof window === 'undefined') return { clickableDivRef };

    useEffect(() => {
        const handleClick = (event) => {
            if (typeof document !== 'undefined' && event?.target) {
                const target = event.target;
                const ariaLabelValue = target?.getAttribute?.('aria-label');
                const isValueTrue = target.classList?.contains?.('goTo');
                if (ariaLabelValue === 'Next Page' || ariaLabelValue === 'Previous Page' || isValueTrue) {
                    dispatch(trackEvent(
                        {
                            eventCategory: 'Product Page',
                            eventAction: 'Reviews',
                            feature_detail: isValueTrue ? target?.innerText : ariaLabelValue.toLowerCase(),
                            eventName: 'feature_interaction',
                            feature_element: 'Reviews',
                            feature_category: 'Product Page',
                        },
                    ));
                }
            }
        };
        const observeDOM = () => {
            const observer = new MutationObserver(() => {
                if (clickableDivRef?.current) {
                    const clickableDiv = clickableDivRef.current;
                    if (clickableDiv && !clickableDiv?.hasListenerAttached) {
                        clickableDiv.addEventListener('click', handleClick);
                        clickableDiv.hasListenerAttached = true; // Flag to indicate the listener is attached
                        observer.disconnect();
                    }
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
        };

        if (typeof document !== 'undefined') {
            observeDOM();
        }

        // Cleanup
        return () => {
            const clickableDiv = clickableDivRef?.current;
            if (clickableDiv && clickableDiv?.hasListenerAttached) {
                clickableDiv.removeEventListener('click', handleClick);
                clickableDiv.hasListenerAttached = false; // Reset the flag
            }
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const element = document?.getElementsByClassName?.('yotpo-review yotpo-regular-box');
            if (typeof document !== 'undefined' && element?.length > 0 && element) {
                const getClientRect = element?.[0]?.getBoundingClientRect() || {};
                const hasDisappeared = getClientRect.bottom < window.innerHeight;
                setIsScrollable(hasDisappeared);
            }
        };

        if (isScrollable) {
            dispatch(trackEvent({
                eventCategory: 'Product Page',
                eventAction: 'Scroll',
                feature_detail: 'Scroll to Reviews',
                eventName: 'feature_interaction',
                feature_element: 'Scroll',
                feature_category: 'Product Page',
            }));
        }
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isScrollable]);

    return { clickableDivRef };
}
